var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFrame),expression:"showFrame"}],staticClass:"full-size",attrs:{"title":"full-slide-frame","src":_vm.slide.embeddedFrameUrl,"frameborder":"0","allowtransparency":""},on:{"load":_vm.onFrameLoaded}})
}
var staticRenderFns = []

export { render, staticRenderFns }